import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form, FormGroup, Label, Input, CustomInput } from 'reactstrap';
import { Link } from 'react-router-dom';
import { cmsServices } from 'js/services';
import { toast } from "react-toastify";

import { EditorComponent, ListLoader } from 'js/components/common';
import { history } from 'js/helpers';

export const TermsConditionsCMS = (props) => {
    const [ state, setState] = useState({
        content : {
            page_title : '',
            top_section : '',
        },
        is_footer_link :0,
        loading: false
    });

    const getStaticPage = () => {
        setState({...state, loading: true})
        cmsServices.getStaticPage('terms-and-conditions')
        .then((response) => {
            setState({ ...state, ...response, loading: false })
        }).catch((err) => {
            setState({ ...state, loading: false })
            toast.error('Failed to Load Page');
            history.push('/admin')
        });
    }

    const updateFooterLinkStatus = () => {
        const newState = { ...state };
        newState.is_footer_link = state.is_footer_link === 1 ? 0 :  1;
        setState(newState);
        cmsServices.setStaticPage(
            'terms-and-conditions',
            newState
        ).then((response) => {
            toast.success('Updated Successfully');
        }).catch((err) => {
            toast.error('Failed to Update Page');
        });
    }

    const handleChange = ( value, key, parent_key ) => {
        const newState = { ...state };
        if( parent_key ){
            newState.content[parent_key][key] = value;
        }
        else{
            newState.content[key] = value;
        }
        setState(newState);
    }

    const setStaticPage = () => {
        cmsServices.setStaticPage(
            'terms-and-conditions',
            state
        ).then((response) => {
            toast.success('Updated Successfully');
        }).catch((err) => {
            toast.error('Failed to Update Page');
        });
    }

    useEffect(() => {
        getStaticPage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const content = state.content;
    return (
        <div>
            <div className="generic-page-header">
                <div className="header-data-section">
                    <Link to={"/admin/static-content"} className="back-btn"><img src="/images/admin/global/back.svg" alt="" /></Link>
                    <h2 className="page-head my-0">Terms & Conditions</h2>
                </div>

                <div className="header-data-section">

                    <div className="user-status">
                        <span>Footer Link
                            <CustomInput
                                type="switch"
                                id="footer_link_switch"
                                checked={ state.is_footer_link === 1 ? true : false }
                                onChange={updateFooterLinkStatus}
                            />
                        </span>
                    </div>
                    <Button color="primary" className="add-new-btn" onClick={setStaticPage}>Save</Button>
                </div>
            </div>
            <div className="tt-admin-card">
                <div className="tt-admin-card--data">
                    <Row className="no-gutters">
                        <Col xs="12">
                            <div className="trip-details-data-section">
                                <Form className="tt-admin-form">
                                {state.loading ?
                                    <ListLoader/>
                                    :
                                    <div className="tt-admin-form-inner">
                                        <Row form>
                                            <Col xs="12">
                                                <FormGroup>
                                                    <Label for="">Page Title</Label>
                                                    <Input
                                                        type="text"
                                                        name="title"
                                                        id="title"
                                                        value={content.page_title}
                                                        onChange = { (e) => handleChange(e.target.value, 'page_title' ) }
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="12">
                                                <div className="editor-outer-wrap">
                                                    <EditorComponent
                                                        id="body"
                                                        content={content.top_section}
                                                        onChange = { (content) => handleChange( content, 'top_section') }
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>
        </div>


    );
}
